import React from 'react'
import classNames from 'classnames';

// STYLE
import './LineBreaker.sass'

const LineBreaker = ({ text, top, bottom, align }) => {
  const componentStyle = {};

  const setComponentStyle = () => {
    return {
      ...componentStyle,
      'marginTop': top ? `${top}` : '0px',
      'marginBottom': bottom ? `${bottom}` : '0px'
    }
  }

  return (
    <div className="LineBreaker" style={setComponentStyle()}>
      { align === 'right' || align !== 'left' ? <div className="LineBreaker__line" /> : null }
      <p className={classNames('LineBreaker__text', {
        'LineBreaker__text--left': align === 'left',
        'LineBreaker__text--right': align === 'right',
        'LineBreaker__text--center': align !== 'left' && align !== 'right',
      })}>{text}</p>
      { align === 'left' || align !== 'right' ? <div className="LineBreaker__line" /> : null }
    </div>
  )
}

export {
  LineBreaker
}